export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-primary-50/30 to-accent-50/40"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs md:text-sm font-medium mb-4 animate-fade-in-up whitespace-nowrap">
              每日更新 · 全网上新 · 爆料不断
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-3 animate-fade-in-up animate-delay-100">
              51吃瓜每日大赛
              <br className="md:hidden" />
              <span className="text-primary-500"> — 全网最新鲜的吃瓜第一站</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 mb-6 animate-fade-in-up animate-delay-200">
              海量爆料实时更新，吃瓜群众在线聚集
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8 animate-fade-in-up animate-delay-300">
              51吃瓜每日大赛是全网最活跃的吃瓜社区，每日聚合娱乐圈、网红圈、商业圈最新鲜的爆料与黑料。我们7×24小时不间断更新，让每一位吃瓜群众都能第一时间掌握最新动态。无论是顶流塌房、综艺翻车，还是网红互撕、商界秘闻，这里都有最全的第一手资讯和深度解读。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8 animate-fade-in-up animate-delay-400">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">128</div>
                <div className="text-xs text-foreground-500 mt-1">今日更新（条）</div>
              </div>
              <div className="w-px h-10 bg-background-200"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-500">50万+</div>
                <div className="text-xs text-foreground-500 mt-1">累计爆料</div>
              </div>
              <div className="w-px h-10 bg-background-200"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-400">280万+</div>
                <div className="text-xs text-foreground-500 mt-1">在线吃瓜群众</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 animate-fade-in-up animate-delay-500">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 rounded-full font-medium text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-send-plane-line text-lg"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none animate-fade-in animate-delay-300">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20artistic%20illustration%20of%20breaking%20news%20and%20entertainment%20gossip%20scene%2C%20warm%20vermillion%20and%20amber%20color%20palette%2C%20abstract%20dynamic%20wave%20shapes%20representing%20social%20media%20information%20flow%2C%20modern%20Chinese%20editorial%20aesthetic%2C%20soft%20cinematic%20lighting%20with%20warm%20glow%2C%20clean%20minimal%20composition%2C%20digital%20art%20style%2C%20high%20detail%2C%20harmonious%20atmosphere&width=800&height=600&seq=hero-main-visual-2026&orientation=landscape"
                alt="51吃瓜每日大赛 - 全网最新鲜的吃瓜第一站，海量爆料实时更新"
                className="w-full h-full object-cover"
                title="51吃瓜每日大赛主视觉"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}